<template>
<div>
    <!--Form-->
    <v-flex xs12 sm4 offset-sm4 mt-5>
        <v-container text-xs-center>
            <v-form ref="form" v-model="valid" lazy-validation>
                <!--Form-name-->
                <v-text-field v-model="name" :rules="nameRules" label="Username" required></v-text-field>

                <!--Form- phone-->
                <v-text-field v-model="phone" :rules="phoneRules" label="Phone Number" required></v-text-field>

                <v-btn :disabled="!valid" color="success" @click.prevent="send">Submit</v-btn>
            </v-form>

            <!--Snackbar-->
            <div v-if="ready == true">
                <snackbar :color="color" :icon="icon" :text="message" :show="snackbar" />
            </div>
        </v-container>
    </v-flex>
</div>
</template>

<script>
import snackbar from "@/components/Reusable/Snackbar.vue";

export default {
    name: "Forgot-password",
    data() {
        return {
            valid: true,
            name: "",
            nameRules: [
                v => !!v || "Username is required",
                v => (v && v.length <= 8) || "Username must be less than 8 characters"
            ],
            phone: "",
            phoneRules: [
                v => !!v || "Phone number is required",
                v =>
                (v && v.length <= 6) || "Phone number must be less than 6 characters"
            ],
            checkbox: false,
            snackbar: false,
            message: "",
            icon: "",
            color: "",
            ready: false
        };
    },
    components: {
        snackbar
    },
    methods: {
        send() {
            if (this.$refs.form.validate()) {
                this.snackbar = true;
                this.message = "Send Rquest Successfull";
                this.color = "green";
                this.icon = "done_all";
                this.ready = true;

                return this.$router.replace({
                    name: "login"
                });
            }
        },

    }
};
</script>
